<template>
  <div v-if="scenarioData && scenarioData.official_playlists" class="banner-scenario-slider">
    <div class="sub-block">
      <!--  -->
      <div class="block-title">
        {{ displayLocaleTitle(scenarioData) }}
      </div>
      <div v-if="hasSliderOption" class="slider-opt">
        <a :class="{'disabled': disablePrev}" class="prev" @click="sliderPrev">
          <i class="material-icons">
            keyboard_arrow_left
          </i>
        </a>
        <a :class="{'disabled': disableNext}" class="next" @click="sliderNext">
          <i class="material-icons">
            keyboard_arrow_right
          </i>
        </a>
      </div>
      <div class="slider-list">
        <ul id="slider" :style="{ transform: 'translateX('+ sliderTransform+'%)'}">
          <li v-for="playlist in scenarioData.official_playlists" :key="playlist.id">
            <RouterLink :to="{ name:'playlistById', params: { locale: $i18n.localePath(), id: playlist.playlist.id} }" :aria-label="playlist.playlist.id" class="list-img" tag="div">
              <img v-img-lazy-loader
                   :data-src="playlist.playlist.file_link"
                   :data-default-src="'/img/img-default/img-playlist-default-l.png'" alt="playlist image"
              >
            </RouterLink>
            <div class="list-info">
              <RouterLink :to="{ name:'playlistById', params: { locale: $i18n.localePath(), id: playlist.playlist.id} }" class="title" tag="div">
                {{ playlist.i18lang[locale] ? playlist.i18lang[locale].title : '' }}
              </RouterLink>
              <div class="desp">
                {{ playlist.i18lang[locale] ? playlist.i18lang[locale].description : '' }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ScenarioService from '@/assets/services/ScenarioService'
import ImgLazyLoader from '@/directives/ImgLazyLoader'
import { displayLocaleTitle } from '@/assets/helpers/ScenarioHelper.js'

export default {
  name: 'ListenScenarioSlider',
  components: {},
  directives: {
    ImgLazyLoader
  },
  props: {},
  data() {
    return {
      // listShow: 0,
      // listCount: 0,
      // listSegment: 0,
      index: 0,
      // lastIndex: 0,
      sliderTransform: 0,
      // hasSliderOption: false,
      disablePrev: false,
      disableNext: false,
      scenarioData: {},
      scenarioId: '8bab9360-7edb-46c5-9aa7-7e4182cd7736' // 精選作曲家
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale.toLowerCase()
    },
    listShow() {
      return this.$isMobile ? 2 : 4
    },
    listCount() {
      return this.scenarioData && this.scenarioData.official_playlists ? this.scenarioData.official_playlists.length : 0
    },
    listSegment() {
      return this.scenarioData && this.scenarioData.official_playlists ? (this.listCount / this.listShow) : 0
    },
    lastIndex() {
      if (this.listShow === 2) {
        return Math.round(this.listSegment) - 1
      } else {
        return ((Math.round(this.listSegment * 10) % 10 > 5) ? (Math.round(this.listSegment) - 1) : (Math.floor(this.listSegment) + 0.5) - 1)
      }
    },
    hasSliderOption() {
      return (this.listCount > this.listShow)
    }
  },
  created() {
  },
  mounted() {
    this.getScenarios()
  },
  methods: {
    displayLocaleTitle,
    sliderInit() {
      // this.listShow = this.$isMobile ? 2 : 4
      // this.listCount = document.getElementById('slider').getElementsByTagName('li').length
      // this.listSegment = (this.listCount / this.listShow)
      // this.hasSliderOption = (this.listCount > this.listShow)
      this.sliderTransform = 0
      this.index = 0
      this.checkOptoin(this.index)
    },
    sliderPrev() {
      if (this.index > 0) {
        if (this.index - 1 > 0) {
          this.sliderTransform = -100 * (--this.index)
        } else {
          this.index = 0
          this.sliderTransform = 0
        }
        this.checkOptoin(this.index)
      }
    },
    sliderNext() {
      if (this.index < (this.lastIndex + 1)) {
        if (this.lastIndex - this.index >= 1) {
          this.sliderTransform = `-${100 * ++this.index}`
        } else {
          this.sliderTransform = `-${100 * this.lastIndex}`
          this.listShow === 2 ? this.index += 1 : this.index += 0.5
        }
        this.checkOptoin(this.index)
      }
    },
    checkOptoin(index) {
      if (index === this.lastIndex || index > this.lastIndex) {
        this.disablePrev = false
        this.disableNext = true
      } else if (index === 0) {
        this.disablePrev = true
        this.disableNext = false
      } else {
        this.disablePrev = false
        this.disableNext = false
      }
    },
    async getScenarios() {
      let res = await ScenarioService.getScenario(this.scenarioId)
      if (res) {
        res.i18lang = {}
        res.langs.forEach(item => {
          res.i18lang[item.locale] = item
        })
        res.official_playlists.forEach(playlist => {
          playlist.i18lang = {}
          playlist.langs.forEach(lang => {
            playlist.i18lang[lang.locale] = lang
          })
        })
        this.scenarioData = res
        this.sliderInit()
        window.addEventListener('resize', this.sliderInit)
      } else {
        this.scenarioData = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.sub-block{
  position: relative;
  padding: 5px 0;
}
.block-title {
  margin: 16px 0;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.64;
  letter-spacing: normal;
  color: $grey-50;
}
.slider-opt{
  position: absolute;
  top: 22px;
  right: 0;
  line-height: 0;
  user-select: none;
  > a{
    display: inline-block;
    width: 36px;
    height: 36px;
    cursor: pointer;
    user-select: none;
    i{
      font-size: 36px;
      color: $grey-50;
    }
    &:last-child{
      margin-left: 16px;
    }
    &.disabled{
      pointer-events: none;
      i{
        cursor: not-allowed;
        color: $btn-grey-bg-disabled;
      }
    }
  }
}
.slider-list{
  overflow: hidden;
  ul{
    display: flex;
    width: 100%;
    height: 470px;
    margin: 0;
    padding: 0;
    list-style: none;
    flex-flow: column wrap;
    column-count: 2;
    transition: 1.5s all cubic-bezier(0.165, 0.84, 0.44, 1);
    li{
      // display: inline-flex;
      width: 50%;
      padding: 0px 48px 40px 0;
      .list-img{
        width: 213px;
        height: 190px;
        float: left;
        border-radius: 12px;
        overflow: hidden;
        cursor: pointer;
        img{
          display: inline-block;
          width: 100%;
          height: auto;
        }
      }
      .list-info{
        overflow: hidden;
        padding-left: 16px;
        .title{
          display: inline;
          font-size: 20px;
          line-height: 1.6;
          margin-bottom: 10px;
          cursor: pointer;
        }
        .desp{
          font-size: 14px;
          font-weight: 500;
          color: $grey-7d;
          line-height: 23px;
          word-wrap: break-word;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 8;
          max-height: 135px;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}

@media only screen and (min-width: 1440px) {
  // As default
}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  .slider-list{
    ul{
      height: 285px;
      li{
        padding: 0px 30px 24px 0;
        .list-img{
          width: 130px;
          height: 116px;
        }
        .list-info{
          .desp{

            font-size: 14px;
            line-height: 23px;
            -webkit-line-clamp: 4;
            max-height: 70px;
          }
        }
      }
    }
  }
}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  .slider-list{
    ul{
      height: 230px;
      li{
        padding: 0px 25px 24px 0;
        .list-img{
          width: 100px;
          height: 89px;
        }
        .list-info{
          .title{
            margin-bottom: 4px;
          }
          .desp{
            font-size: 12px;
            line-height: normal;
            -webkit-line-clamp: 3;
            max-height: 52px;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 767.98px) {
  .slider-list{
    ul{
      height: 280px;
      li{
        width: 100%;
        padding: 0 0 16px 0;
        .list-img{
          width: 80px;
          height: 71px;
        }
        .list-info{
          padding-left: 8px;
          .title{
            margin-bottom: 4px;
          }
          .desp{
            font-size: 12px;
            line-height: normal;
            -webkit-line-clamp: 5;
            max-height: 90px;
            height: 88px;
          }
        }
      }
    }
  }
}
</style>
